import React, { useState, useEffect } from "react";
import HeroSection from "../components/home/HeroSection";
import KeyHighlights from "../components/home/KeyHighlights";
import FeaturedProducts from "../components/home/FeaturedProducts";
import PageContainer from "../components/layout/PageContainer";
import ElevatorAnimation from "../components/animations/ElevatorAnimation";
import WhyChooseUs from "../components/home/WhyChooseUs";
import ContactForm from "../components/contact/ContactForm";

const Home = () => {
  const [animationComplete, setAnimationComplete] = useState(false);
  const [showContent, setShowContent] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  const checkMobile = () => {
    setIsMobile(window.innerWidth < 820);
  };

  // Check for mobile screen size on mount and resize
  useEffect(() => {
    // Initial check
    checkMobile();

    // Add resize listener
    window.addEventListener("resize", checkMobile);

    // If mobile, skip animation and show content immediately
    if (isMobile) {
      setAnimationComplete(true);
      setShowContent(true);
    }

    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  return (
    <PageContainer>
      <HeroSection />
      <WhyChooseUs />
      <FeaturedProducts />
      <KeyHighlights />
      <div
        style={{
          position: "relative",
          maxWidth: checkMobile? "100%" : "60vw",
          alignItems: "center",
          margin: "0 auto 30px",
        }}
      >
        <ContactForm />
      </div>
    </PageContainer>
  );
};

export default Home;
